module.exports = __webpack_public_path__ + "8efbd5e409a8bcf1da63e40cc9e2150b.png";